'use client'

import { useEffect, useRef } from 'react'

/**
 * @param callback
 * @param delay - in milliseconds
 * @param skip
 */
const useTimeout = (callback: () => void, delay?: number, skip?: boolean) => {
  const savedCallback = useRef<() => void>()

  useEffect(() => {
    if (skip) return

    savedCallback.current = callback
  }, [callback, skip])

  useEffect(() => {
    if (skip) return

    function tick() {
      savedCallback.current?.()
    }
    // istanbul ignore next
    if (delay !== null) {
      let id = setTimeout(tick, delay)
      return () => clearInterval(id)
    }

    /* istanbul ignore next */
    return
  }, [delay, skip])
}

export default useTimeout
